import { BasicService } from "./core/basic.service";

export class ArticleService extends BasicService {
  static async getList() {
    const data = await this.http.post('/article/articleList')
    return Promise.resolve(data)
  }
  static async articleDetail(id) {
    const data = await this.http.post('/article/detail',{id})
    return Promise.resolve(data)
  }
  static async customviewDetail(id) {
    const data = await this.http.post('/custom_view/customViewDetail',{ id })
    return Promise.resolve(data)
  }
}